import React from "react";

const BackToPayroll = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M27.6 26v3.2a1.606 1.606 0 001.6 1.6 1.606 1.606 0 001.6-1.6V26h-3.2zm0-3.2V3.6A1.606 1.606 0 0026 2H3.6A1.606 1.606 0 002 3.6v25.6a4.8 4.8 0 001.41 3.39A4.8 4.8 0 006.8 34h22.4a4.8 4.8 0 003.39-1.41A4.8 4.8 0 0034 29.2v-6.4h-6.4zm-11.15-1.97l-.05-4.86c-1.76.15-3.44.85-4.73 2.21-.73.76-1.29 1.66-1.67 2.64-.37.99-.54 2.03-.5 3.08.05 1.09.33 2.16.82 3.14l-2.24.78c-.96-2.05-1.21-4.36-.69-6.56a9.96 9.96 0 012.63-4.74 9.628 9.628 0 016.39-2.99l-.05-4.87 6.13 6.04-6.04 6.13z"
            fill={fill}
        />
    </svg>
);

export default BackToPayroll;